import InputTodo from "./components/InputTodo";

function App() {
  return <div>
    <h1>My Todos</h1>
    <hr></hr>
    <InputTodo />
  </div>;
}

export default App;
